import { render, staticRenderFns } from "./modal-card-academica.vue?vue&type=template&id=299a81ef&"
import script from "./modal-card-academica.vue?vue&type=script&lang=js&"
export * from "./modal-card-academica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports